import getEventDoctorApi from './getEventDoctorApi';

export default {
  getEventDoctorApi,
};
